export enum RequestLocalStorageKey {
    GET_PLACE_DETAILS_REQUEST = 'getPlaceDetailsRequest',
    GET_PLACE_DIAGNOSTIC_REQUEST = 'getPlaceDiagnosticRequest',
    SEARCH_REQUEST = 'searchRequest',
}

export enum OtherLocalStorageKey {
    LANG = 'lang',
    JWT_TOKEN = 'jwtToken',
    USER_IDENTITY = 'userIdentity',
    IS_EVENT_DEFAULT_LANGUAGE_SET = 'isEventDefaultLanguageSet',
}

export enum CookieKey {
    HUBSPOT_UTK = 'hubspotutk',
}
